export default {
  message: '',
  email: ''
}